<template>
  <div
    class="flex items-center justify-center aspect-square rounded-full hover:opacity-80 cursor-pointer"
    :class="{
      'p-0 h-[18px]': props.xsmall,
      'p-0 h-[24px]': props.small,
      'p-1 h-[48px]': props.little,
      'p-1 h-[68px]': !props.small && !props.xsmall && !props.little,
    }"
    :style="outerStyle"
  >
    <div
      class="flex items-center justify-center aspect-square rounded-full"
      :class="{
        'p-0 h-[18px] text-baseplus': props.xsmall,
        'p-0 h-[24px] text-lg': props.small,
        'p-4 h-[58px] text-2xl': !props.small && !props.xsmall && !props.little,
        'p-2 h-[38px] text-xl': props.little,
      }"
      :style="innerStyle"
    >
      <img
        src="/assets/micons/ic_fluent_drop_24_filled.svg"
        :class="{ 'h-5': props.little, 'h-7': !props.little }"
        v-if="props.water"
      />
      <ion-icon v-else :icon="props.icon || $icons.addOutline"></ion-icon>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { useDomain } from "@/composable/useDomain";

const { isFreshWater } = useDomain();

const props = defineProps({
  icon: Object,
  little: Boolean,
  small: Boolean,
  xsmall: Boolean,
  water: Boolean,
  internalTransparent: Boolean,
  textWhite: Boolean,
});

const baseColor = computed(() => isFreshWater.value ? "#4A8C5E" : "#6F94E0");
const waterColor = computed(() => isFreshWater.value ? "#41C969" : "#2970E6");

const outerStyle = computed(() => {
  if (props.water) {
    if (props.little) {
      return {
        backgroundColor: waterColor.value,
        border: "none",
      };
    }
    return {
      border: `3px solid ${waterColor.value}`,
      backgroundColor: "transparent",
    };
  }
  return {
    backgroundColor: baseColor.value,
    border: "none",
  };
});

const innerStyle = computed(() => {
  if (props.water) {
    return {
      backgroundColor: props.little ? "transparent" : waterColor.value,
      color: "#fff",
      border: "none",
    };
  }
  return {
    backgroundColor: "transparent",
    border: "2px solid #fff",
    color: "#fff",
  };
});
</script>
